import { render, staticRenderFns } from "./ItemsReceivedListRep.vue?vue&type=template&id=0fa29509&"
import script from "./ItemsReceivedListRep.vue?vue&type=script&lang=js&"
export * from "./ItemsReceivedListRep.vue?vue&type=script&lang=js&"
import style0 from "./ItemsReceivedListRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports